// Types
export const INSERIR_ALUNO = 'app/filtro/INSERIR_ALUNO';
export const INSERIR_MARCA = 'app/filtro/INSERIR_MARCA';
export const INSERIR_CAMPI = 'app/filtro/INSERIR_CAMPI';
export const INSERIR_CURSO = 'app/filtro/INSERIR_CURSO';
export const INSERIR_MODALIDADE = 'app/filtro/INSERIR_MODALIDADE';
export const INSERIR_TURNO = 'app/filtro/INSERIR_TURNO';
export const INSERIR_PERIODO_LETIVO = 'app/filtro/INSERIR_PERIODO_LETIVO';
export const INSERIR_INGRESSO = 'app/filtro/INSERIR_INGRESSO';
export const INSERIR_AUXILIAR = 'app/filtro/INSERIR_AUXILIAR';
export const INSERIR_ESTADO_FILTRO = 'app/filtro/INSERIR_ESTADO_FILTRO';

// Reducer
export const INITIAL_STATE = {
  aluno: [],
  marca: [],
  campi: [],
  curso: [],
  modalidade: [],
  turno: [],
  periodoLetivo: [],
  ingresso: [],

  auxiliar: null,
  estadoFiltroAplicado: false,
};

export default function reducer(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case INSERIR_ALUNO:
      return {
        ...state,
        aluno: action.payload,
      };
    case INSERIR_MARCA:
      return {
        ...state,
        marca: action.payload,
      };
    case INSERIR_CAMPI:
      return {
        ...state,
        campi: action.payload,
      };
    case INSERIR_CURSO:
      return {
        ...state,
        curso: action.payload,
      };
    case INSERIR_MODALIDADE:
      return {
        ...state,
        modalidade: action.payload,
      };
    case INSERIR_TURNO:
      return {
        ...state,
        turno: action.payload,
      };
    case INSERIR_PERIODO_LETIVO:
      return {
        ...state,
        periodoLetivo: action.payload,
      };
    case INSERIR_INGRESSO:
      return {
        ...state,
        ingresso: action.payload,
      };
    case INSERIR_AUXILIAR:
      return {
        ...state,
        auxiliar: action.payload,
      };
    case INSERIR_ESTADO_FILTRO:
      return {
        ...state,
        estadoFiltroAplicado: action.payload,
      };
    default:
      return state;
  }
}

// Action creators
export const atualizarAluno = (aluno) => {
  return {
    type: INSERIR_ALUNO,
    payload: aluno,
  };
};

export const atualizarMarca = (marca) => {
  return {
    type: INSERIR_MARCA,
    payload: marca,
  };
};

export const atualizarCampus = (campi) => {
  return {
    type: INSERIR_CAMPI,
    payload: campi,
  };
};

export const atualizarCurso = (curso) => {
  return {
    type: INSERIR_CURSO,
    payload: curso,
  };
};

export const atualizarModalidade = (modalidade) => {
  return {
    type: INSERIR_MODALIDADE,
    payload: modalidade,
  };
};

export const atualizarTurno = (turno) => {
  return {
    type: INSERIR_TURNO,
    payload: turno,
  };
};

export const atualizarPeriodo = (periodoLetivo) => {
  return {
    type: INSERIR_PERIODO_LETIVO,
    payload: periodoLetivo,
  };
};

export const atualizarIngresso = (ingresso) => {
  return {
    type: INSERIR_INGRESSO,
    payload: ingresso,
  };
};

export const atualizarAuxiliar = (auxiliar) => {
  return {
    type: INSERIR_AUXILIAR,
    payload: auxiliar,
  };
};

export const atualizarEstadoFiltro = (estado) => {
  return {
    type: INSERIR_ESTADO_FILTRO,
    payload: estado,
  };
};
